import type { MouseEventHandler } from 'react';
import { FaFacebookSquare, FaInstagram } from 'react-icons/fa';
import { useNavigate } from 'react-router';

import { Grid, Link } from '@mui/material';

import { styles } from './constants';
import Menu from './menu';
import { useScrollableLink } from '../hooks/use-scrollable-link';

import './footer.scss';

function Footer() {
  const navigate = useNavigate();
  const { get: getScrollableLink } = useScrollableLink();

  const onMenuClick = (link: string): void & MouseEventHandler<HTMLButtonElement> => {
    navigate(`/#${link}`);
  };

  return (
    <>
      <Grid container spacing={2} className={'footer'}>
        <Menu customClass="menu footerMenu" offset={{ lg: 2 }} size={{ md: 2 }} onClick={onMenuClick} />
        <Grid size={{ md: 1 }} className={'iconsContainer'}>
          <Link href="https://www.facebook.com/@icesportsvarnafs" target="_blank">
            <FaFacebookSquare />
          </Link>
          <Link href="https://www.instagram.com/figureskating.varna" target="_blank">
            <FaInstagram />
          </Link>
        </Grid>
        <Grid size={{ md: 7 }} className={'imagesContainer'}>
          {getScrollableLink(
            <img src="images/ice_sports_varna_logo_w.png" alt="Ice Sports Varna" />,
            styles.ids.root,
            () => onMenuClick('')
          )}
          <Link href="https://toprentacar.bg" target="_blank">
            <img src="images/top-rent-a-car-logo.jpg" alt="Top rent a car" />
          </Link>
          <Link href="https://whitewater.bg" target="_blank">
            <img src="images/white-water.jpg" alt="White water" />
          </Link>
        </Grid>
      </Grid>
    </>
  );
}

export default Footer;
